import HeaderCell from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/HeaderCell'
import withAlignment, {
  Alignment
} from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/Alignment'
import { VerticalAlignment } from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/Alignment/Alignment'
import {
  Column,
  ColumnType
} from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import { UserRoles } from '@modules/common'
import Currency from '@modules/order/components/CellTemplates/Currency'
import withCustomField from '@modules/order/components/CellTemplates/CustomFieldHOC'
import FieldData from '@modules/order/components/CellTemplates/FieldData'
import NoContent from '@modules/order/components/CellTemplates/NoContent'
import ProductInfo from '@modules/order/components/CellTemplates/ProductInfo'
import BookQty from '@modules/order/components/CellTemplates/Quantities/BookQty'
import DraftUnSizedQuantity from '@modules/order/components/CellTemplates/Quantities/DraftUnSizedQuantity'
import HierarchyQuantityValue from '@modules/order/components/CellTemplates/Quantities/HierarchyQuantityValue'
import { Quantity } from '@modules/order/components/CellTemplates/Quantities/Quantity'
import RMClusters from '@modules/order/components/CellTemplates/Quantities/RMClusters'
import ActivityFamilyLine from '@modules/order/components/CellTemplates/Quantities/ActivityFamilyLine'
import AverageDepth from '@modules/order/components/CellTemplates/Summary/AverageDepth'
import AverageWeekSales from '@modules/order/components/CellTemplates/Summary/AverageWeekSales'
import CMClusters from '@modules/order/components/CellTemplates/Summary/CMClusters'
import Comment from '@modules/order/components/CellTemplates/Summary/Comment'
import DraftQuantity from '@modules/order/components/CellTemplates/Summary/DraftQuantity'
import HierarchyKPICurrencyDetails from '@modules/order/components/CellTemplates/Summary/HierarchyKPICurrencyDetails'
import QuantityHeaderWithKPI from '@modules/order/components/CellTemplates/Quantities/QuantitiesWithKPI/QunatityHeaderWithKPI'
import HierarchyKPIDetails from '@modules/order/components/CellTemplates/Summary/HierarchyKPIDetails'
import RMClustersForSummary from '@modules/order/components/CellTemplates/Summary/RMClusters'
import TotalStores from '@modules/order/components/CellTemplates/Summary/TotalStores'
import groupBy from 'lodash/groupBy'
import ViewSettingStore from '../../ViewSettingStore'
import { QuantityType } from '@components/UI-Components/QuantityType/constants/QuantityType'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import {
  getQuantityKPIColumns,
  getQuantityKPILabels
} from '@modules/order/constants/QuantityHeaderKPI'
import * as css from './ListViewTableService.css'
import { nav } from '@stores'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { getEnumValue } from '@utils/get-enum-value'
import SalesPeriod from '@modules/order/components/CellTemplates/Summary/SalesPeriod/SalesPeriod'
import RollUpButton from '@modules/order/components/CellTemplates/Quantities/QuantitiesWithKPI/RollUpButton'
import NumberFieldData from '@api/order/components/CellTemplates/NumberFieldData'
import { config } from '@config'
import { DefaultConfig } from '@constants'
import { ASSORTMENT_SOURCE } from '@constants'
import sortBy from 'lodash/sortBy'

export enum ListTableView {
  Quantity = 'Quantity',
  Summary = 'Summary'
}

export const QUANTITIES_AND_BOOK = 'quantitiesAndBook'
export default class ListViewTableService extends ViewSettingStore {
  getFixedColumns: () => Column[] = () => {
    return [
      {
        field: 'name',
        width: 332,
        label: 'Activity/ Family/ Line',
        key: 'activityFamilyLine',
        fixed: true,
        showHeader: true,
        allowHide: false,
        showBorders: true,
        cellElement: ProductInfo,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          HeaderCell,
          Alignment.LEFT,
          VerticalAlignment.CENTER,
          css.cellAlignment
        ),
        hierarchyRowCellTemplate: withAlignment(
          ActivityFamilyLine,
          Alignment.LEFT,
          VerticalAlignment.CENTER
        )
      }
    ]
  }

  getColumnsForSummaryView() {
    return [
      {
        field: 'clusters',
        width: 150,
        label: 'CM Clusters',
        key: 'clusters',
        showBorders: true,
        cellElement: CMClusters,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true
      },
      {
        field: 'rmClusters',
        width: 150,
        label: 'RM Clusters',
        key: 'rmClusters',
        showBorders: true,
        cellElement: RMClustersForSummary,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.totalByProductQuantity',
        width: 150,
        label: 'Product Quantity',
        key: 'summary.totalByProductQuantity',
        showBorders: true,
        cellElement: DraftQuantity,
        hierarchyRowCellTemplate: HierarchyKPIDetails,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.totalByForecastQuantity',
        width: 150,
        label: 'Forecast Quantity',
        key: 'summary.totalByForecastQuantity',
        showBorders: true,
        cellElement: FieldData,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.totalByForecastQuantity', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.totalValueByProductQuantity',
        width: 150,
        label: 'Product Value',
        key: 'summary.totalValueByProductQuantity',
        showBorders: true,
        cellElement: Currency,
        hierarchyRowCellTemplate: HierarchyKPICurrencyDetails,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.totalValueByForecastQuantity',
        width: 150,
        label: 'Forecast Value',
        key: 'summary.totalValueByForecastQuantity',
        showBorders: true,
        cellElement: Currency,
        hierarchyRowCellTemplate: HierarchyKPICurrencyDetails,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.totalByDraftQuantity',
        width: 150,
        label: 'Door Quantity',
        key: 'summary.totalByDraftQuantity',
        showBorders: true,
        cellElement: FieldData,
        hierarchyRowCellTemplate: HierarchyKPIDetails,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.totalValueByDraftQuantity',
        width: 150,
        label: 'Door Value',
        key: 'summary.totalValueByDraftQuantity',
        showBorders: true,
        cellElement: Currency,
        hierarchyRowCellTemplate: HierarchyKPICurrencyDetails,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.avgWeeklySales',
        width: 150,
        label: 'Average Week Sales',
        key: 'summary.avgWeeklySales',
        showBorders: true,
        cellElement: AverageWeekSales,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.averageWeeklySales', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.forecastAvgWeeklySales',
        width: 150,
        label: 'Forecast Avg WK Sales',
        key: 'summary.forecastAvgWeeklySales',
        showBorders: true,
        cellElement: NumberFieldData,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.forecastAverageWeeklySales', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.avgDepth',
        width: 150,
        label: 'Average Depth',
        key: 'summary.avgDepth',
        showBorders: true,
        cellElement: AverageDepth,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.avgDepth', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.forecastAvgDepth',
        width: 150,
        label: 'Forecast Avg Depth',
        key: 'summary.forecastAvgDepth',
        showBorders: true,
        cellElement: NumberFieldData,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.forecastAvgDepth', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.doorProducts',
        width: 150,
        label: 'Total Stores',
        key: 'summary.doorProducts',
        showBorders: true,
        isAlignCenter: false,
        cellElement: TotalStores,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.numberOfStores', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.forecastTotalStores',
        width: 150,
        label: 'Forecast Total Stores',
        key: 'summary.forecastTotalStores',
        showBorders: true,
        isAlignCenter: false,
        cellElement: FieldData,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: { field: 'summary.forecastNumberOfStores', label: '' }
        }),
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.salesPeriod',
        width: 150,
        label: 'Sales Period',
        key: 'summary.salesPeriod',
        showBorders: true,
        cellElement: SalesPeriod,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.salesPeriodWeeks',
        width: 150,
        label: 'Sales Period Weeks',
        key: 'summary.salesPeriodWeeks',
        showBorders: true,
        cellElement: FieldData,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true
      },
      {
        field: 'summary.orderProduct.salesQuantity',
        width: 150,
        label: 'Sales Quantity',
        key: 'summary.salesQuantity',
        showBorders: true,
        cellElement: NumberFieldData,
        hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
          column: {
            field: 'summary.salesQuantity',
            label: ''
          }
        }),
        allowReordering: true
      },
      {
        field: 'summary.productComments.RM',
        width: 200,
        label: 'RM Comments',
        key: 'productComments.RM',
        showBorders: true,
        isAlignCenter: false,
        cellElement: Comment({
          commentType: 'RM',
          allowedUserRoles: [UserRoles.REGIONAL_MERCHANDISER]
        }),
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true
      },
      {
        field: 'summary.productComments.CM',
        width: 200,
        label: 'CM Comments',
        key: 'productComments.CM',
        showBorders: true,
        isAlignCenter: false,
        cellElement: Comment({
          commentType: 'CM',
          allowedUserRoles: []
        }),
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true
      }
    ] as Column[]
  }

  getColumnsForQtyView(
    captureSize: boolean,
    isValueSelected?: boolean,
    quantityType?: string,
    kpiLabels?: any[]
  ) {
    const isRetail = getEnumValue(VIPClientType.Internal) === nav.queryParams?.clientType
    return [
      {
        field: 'quantity.totalByProductQuantity',
        width: 140,
        label: 'Product Quantity',
        key: 'quantity.totalByProductQuantity',
        showBorders: true,
        fixed: true,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          RollUpButton(),
          Alignment.LEFT,
          VerticalAlignment.CENTER,
          css.groupedCell
        ),
        cellElement: DraftUnSizedQuantity,
        cellAlignment: false,
        hierarchyRowCellTemplate: HierarchyKPIDetails
      },
      {
        field: QUANTITIES_AND_BOOK,
        width: 166,
        label:
          quantityType === QuantityType.Product
            ? isRetail
              ? `Door ${captureSize ? '/ Sized ' : ''}QTY`
              : `Draft ${captureSize ? '/ Sized ' : ''}QTY`
            : `${
                quantityType === QuantityType.Size && captureSize
                  ? 'Sized'
                  : isRetail
                  ? 'Door'
                  : 'Draft'
              } ${isValueSelected ? 'Value' : 'QTY'}`,
        key:
          quantityType === QuantityType.Product
            ? isRetail
              ? `door${captureSize ? 'Sized' : ''}QTY`
              : `draft${captureSize ? 'Sized' : ''}QTY`
            : `${
                quantityType === QuantityType.Size && captureSize
                  ? 'sized'
                  : isRetail
                  ? 'door'
                  : 'draft'
              } ${isValueSelected ? 'Value' : 'QTY'}`,
        fixed: true,
        showBorders: false,
        cellElement: BookQty,
        headerCellElement: withAlignment(
          QuantityHeaderWithKPI({ headers: kpiLabels, doorOrderId: null }),
          Alignment.LEFT,
          VerticalAlignment.CENTER,
          css.groupedCell
        ),
        cellAlignment: false,
        hierarchyRowCellTemplate: HierarchyQuantityValue
      }
    ] as Column[]
  }

  getColumnsForQtyViewForRetail(
    captureSize: boolean,
    isValueSelected?: boolean,
    quantityType?: string,
    kpiLabels?: any[]
  ) {
    return [
      {
        field: 'rmClusters',
        width: 140,
        label: 'RM Clusters',
        key: 'rmClusters',
        showBorders: true,
        fixed: true,
        cellElement: RMClusters,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          HeaderCell,
          Alignment.CENTER,
          VerticalAlignment.CENTER,
          css.cellAlignment
        ),
        hierarchyRowCellTemplate: NoContent
      },
      {
        field: 'clusters',
        width: 140,
        label: 'CM Clusters',
        key: 'clusters',
        showBorders: true,
        cellElement: CMClusters,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          HeaderCell,
          Alignment.CENTER,
          VerticalAlignment.CENTER,
          css.cellAlignment
        ),
        hierarchyRowCellTemplate: NoContent
      },
      ...((config.displayAvgDepthAndTotalStoresInQtyView ||
        DefaultConfig.DISPLAY_AVG_DEPTH_AND_TOTAL_STORES_IN_QTY_VIEW) === 'true'
        ? [
            {
              field: 'quantity.avgDepth',
              width: 140,
              label: 'Average Depth',
              key: 'quantity.avgDepth',
              showBorders: true,
              className: css.headerPosition,
              headerCellElement: withAlignment(
                HeaderCell,
                Alignment.CENTER,
                VerticalAlignment.CENTER,
                css.cellAlignment
              ),
              cellElement: AverageDepth,
              hierarchyRowCellTemplate: HierarchyKPIDetails
            },
            {
              field: 'quantity.doorProducts',
              width: 140,
              label: 'Total Stores',
              key: 'quantity.doorProducts',
              className: css.headerPosition,
              showBorders: true,
              cellElement: TotalStores,
              headerCellElement: withAlignment(
                HeaderCell,
                Alignment.CENTER,
                VerticalAlignment.CENTER,
                css.cellAlignment
              ),
              hierarchyRowCellTemplate: withCustomField(HierarchyKPIDetails, {
                column: { field: 'summary.numberOfStores', label: '' }
              })
            }
          ]
        : []),
      ...this.getColumnsForQtyView(captureSize, isValueSelected, quantityType, kpiLabels)
    ] as Column[]
  }

  getColumnForDoor(doorOrder: any, quantityKPIS: any[], allowReordering: boolean) {
    return {
      field: doorOrder.id,
      label: doorOrder.door.name,
      width: doorOrder.door.name?.length > 30 ? 140 : 100,
      allowHide: true,
      showBorders: false,
      allowReordering,
      headerCellElement: withAlignment(
        QuantityHeaderWithKPI({ headers: quantityKPIS, doorOrderId: doorOrder.door.id }),
        Alignment.LEFT,
        VerticalAlignment.CENTER,
        css.groupedCell
      ),
      cellElement: Quantity,
      cellAlignment: false,
      hierarchyRowCellTemplate: HierarchyQuantityValue
    } as Column
  }

  getClusteredDoors(doorOrders: any[], quantityKPIS: any[]) {
    if (config.assortmentSource.retail === ASSORTMENT_SOURCE.CLUSTER_GROUP) {
      return sortBy(doorOrders, ['door.sortOrder', 'door.name']).map(doorOrder =>
        this.getColumnForDoor(doorOrder, quantityKPIS, true)
      ) as Column[]
    } else {
      let groupedDoors = groupBy(doorOrders, 'door.cluster.id')
      return Object.keys(groupedDoors)
        .sort(
          (clusterId1, clusterId2) =>
            groupedDoors[clusterId1][0].door.cluster.sortOrder -
            groupedDoors[clusterId2][0].door.cluster.sortOrder
        )
        .map(clusterId => ({
          field: clusterId,
          label: groupedDoors[clusterId][0].door.cluster.name || 'Unclustered',
          filterSubColumns: true,
          showHeader: true,
          allowHide: true,
          showBorders: true,
          allowReordering: true,
          type: ColumnType.Grouped,
          columns: groupedDoors[clusterId]
            .sort(
              (doorOrder1, doorOrder2) =>
                doorOrder1.door.sortOrder - doorOrder2.door.sortOrder
            )
            .map(doorOrder => this.getColumnForDoor(doorOrder, quantityKPIS, true)),
          cellElement: Quantity
        })) as Column[]
    }
  }

  // doors =  doorOrders
  getColumns: (
    doorOrders: any[],
    groupedDoors?: boolean,
    captureSize?: boolean,
    isValueSelected?: boolean,
    quantityType?: string
  ) => Column[] = (
    doorOrders,
    groupedDoors,
    captureSize,
    isValueSelected,
    quantityType
  ) => {
    return [
      ...this.getFixedColumns(),
      ...(doorOrders?.length
        ? groupedDoors
          ? [
              ...this.getColumnsForQtyViewForRetail(
                captureSize,
                isValueSelected,
                quantityType,
                getQuantityKPILabels(quantityType, VIPChannel.Retail)
              ),
              ...this.getClusteredDoors(
                doorOrders,
                getQuantityKPIColumns(quantityType, VIPChannel.Retail)
              )
            ]
          : [
              ...this.getColumnsForQtyView(
                captureSize,
                isValueSelected,
                quantityType,
                getQuantityKPILabels(quantityType, VIPChannel.Wholesale)
              ),
              ...doorOrders
                .sort(
                  (doorOrder1, doorOrder2) =>
                    doorOrder1.door.sortOrder - doorOrder2.door.sortOrder
                )
                .map(doorOrder =>
                  this.getColumnForDoor(
                    doorOrder,
                    getQuantityKPIColumns(quantityType, VIPChannel.Wholesale),
                    false
                  )
                )
            ]
        : this.getColumnsForSummaryView())
    ]
  }
}
